// extracted by mini-css-extract-plugin
export default {"search":"search_search__Bx742","input":"search_input__9AFuA"};